import { useState } from 'react';
import { Field } from 'formik';
import styled from 'styled-components';
const Input = ({
	name,
	placeholder,
	type,
	label,
	disabled,
	maxlength,
	quitError,
	toUpperCase,
	isCurrency,
	value,
}) => {
	const [isEditing, setIsEditing] = useState(false);
	const formatCurrency = () => {
		if (value === null || value === undefined || value === '') return '';
		const numberValue =
			typeof value === 'string' ? parseFloat(value.replace(/[^0-9.-]+/g, '')) : value;

		return isNaN(numberValue) || numberValue === 0
			? '$0.00'
			: numberValue.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
	};

	const handleFocus = () => {
		setIsEditing(true);
	};

	const handleBlur = (field, setFieldValue) => {
		setIsEditing(false);
		if (isCurrency && field.value) {
			const formattedValue = field.value.replace(/[^0-9.]/g, '');
			setFieldValue(name, formattedValue);
		}
	};

	return (
		<>
			<Field name={name}>
				{({ field, form: { setFieldValue }, meta }) => (
					<InputWrap>
						{label && <Label>{label}</Label>}
						<MyStyledInput
							type={type}
							placeholder={placeholder}
							className={meta.touched && meta.error ? 'error' : ''}
							disabled={disabled}
							maxLength={maxlength}
							toUpperCase={toUpperCase}
							{...field}
							value={isEditing || !isCurrency ? field.value : formatCurrency(field.value)}
							onFocus={handleFocus}
							onBlur={() => handleBlur(field, setFieldValue)}
						/>
						{meta.touched && meta.error && !quitError && <MyError>{meta.error}</MyError>}
					</InputWrap>
				)}
			</Field>
		</>
	);
};
const InputWrap = styled.div`
	width: 100%;
	position: relative;
	label {
		margin-bottom: 0.5em;
		display: block;
		padding-left: 5px;
	}
`;
const MyStyledInput = styled.input`
	padding: 1em 0.8em;
	width: 100%;
	display: block;
	background: #fff;
	border: 1px solid ${props => props.theme.separatorColor};
	border-radius: 5px;
	outline: none;
	color: ${props => props.theme.fontColor};
	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	&.error {
		border: 1px solid red;
	}
	&:-webkit-autofill {
		appearance: inherit;
		background-color: inherit !important;
		background-image: none !important;
		color: inherit !important;
	}
	&::placeholder {
		/* Chrome, Firefox, Opera, Safari 10.1+ */
		color: ${props => props.theme.separatorColor};
		opacity: 1; /* Firefox */
		text-transform: none !important;
	}
	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */
	&[type='number'] {
		-moz-appearance: textfield;
	}
	${props => {
		if (props.toUpperCase) {
			return `text-transform: uppercase;`;
		}
	}}
`;
const MyError = styled.div`
	color: red;
	padding: 0.3em;
	position: absolute;
	top: 100%;
	transform: translateY(-2px);
	font-size: 10px;
	z-index: 9996;
`;
const Label = styled.label`
	display: flex !important;
	align-items: center;
`;
export default Input;
